import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { NotificationEmail, SendEmail } from 'src/app/shared/models/notificationEmail';
import { Prestation } from 'src/app/shared/models/prestation';
import { NotificationType } from 'src/app/shared/enums/notification-type.enum';
import { BonCommande } from 'src/app/shared/models/bonCommande';

@Component({
	selector: 'app-bonCommande-modal-ajout-form',
	templateUrl: './bonCommande-modal-ajout-form.component.html',
	styleUrls: ['./bonCommande-modal-ajout-form.component.scss']
})
export class BonCommandeModalAjoutFormComponent implements OnInit {
	LABEL_BENEFICIAIRE: string;
	serviceCenter: ServiceCenter;
	enumCompetences;

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	isPreferencesActive = false;
	notificationEmail : NotificationEmail;
	sendMail = new SendEmail();
	listNotificationType = NotificationType;

	bonCommande = new BonCommande();

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";

	form = this.fb.group({
		marche: new FormControl(''),
		description: new FormControl(''),
		lot: new FormControl(''),
		descriptionLot: new FormControl(''),
		commande: new FormControl(''),
		dateDebut: new FormControl<Date>(null),
		dateFin: new FormControl<Date>(null),
		responsable: new FormControl(''),
		adjudicateur: new FormControl(''),
		adresseFacturation: new FormControl(''),
		titulaire: new FormControl(''),
		region: new FormControl(),
		references: this.fb.array([this.fb.group({
			reference: '',
			description: '',
			cible: '',
			quantite: '',
			prix: '',
			unite: ''
		})]),
		services: this.fb.array([this.fb.group({
			service: '',
			pourcentageCharge: ''
		})])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	@Output() updateListing = new EventEmitter();


	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private toastService: ToastService,
		private fb: FormBuilder
	) {}

	ngOnInit(): void {

	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		console.log(this.bonCommande);
		this.facade.bonCommandeService
			.addBonCommande(this.bonCommande)
			.subscribe({
				next: (savedBonCommande: BonCommande) => {
					this.bonCommande.id = savedBonCommande.id;
					this.isValidateButtonClicked.value = false;
					this.bsModalRef.hide();
					this.updateListing.emit(this.bonCommande);
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}
}
